import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'shig-footer',
    templateUrl: './footer.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
    protected readonly currentYear = new Date().getFullYear();

    protected openLink(link: string): void {
        window.open(link, '_blank');
    }
}
